export { default } from "./videoPage";
